import { Box, Divider, IconButton, Paper, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import NormalTable from "../../../../Component/NormalTable";
import { color } from "../../../../StyleData/Config";
import { masterAPI } from "../../../Masters/dataConfig";
import { axiosPrivate } from "../../../../axios/axios";
import { DeleteOutline, EditOutlined } from "@mui/icons-material";
import Labour from "./LabourCreate";
import { Add } from "@mui/icons-material";
import LabourCreate from "./LabourCreate";
import LabourEdit from "./LabourEdit";
import { useSearchParams } from "react-router-dom";
import { decode } from "../../../../Component/JWT/Formatt";

import ResponsiveDialog from "../../../../Component/ResponsiveDialog";
const WorkAssignment = ({ woData ,enableDisable }) => {
  const trueDisable=!enableDisable.edit
  const [searchParams,setSearchParams]=useSearchParams()
  const [dataList, setDataList] = useState([]);
  const [createLab,setCreateLab]=useState(false)
  const [editLabour,setEditLabour]=useState(false)
  const [editData,setEditData]=useState({})

  useEffect(() => {
getData()
  }, []);

  const getData=async()=>{
    const wolabLink=masterAPI["inspWoLabour"].getLabourByIWid
    // axiosPrivate.get(`${wolabLink}/${woData.id}`).then(res=>{
  await axiosPrivate.get(`${wolabLink}?inspectionWorkOrderId=${decode(searchParams.get("id"))}`).then(res=>{
    console.log(res.data.result)
    setDataList(res.data.result)
}).catch(e=>{
  setDataList([])
    console.log(e,"error wo assignment")
})
  }

  const handleEdit=(value)=>{
  setEditLabour(true)
  setEditData(value)
  }

  const handleClose=()=>{
    setEditData({})
    setEditLabour(false)
    getData()
  }

  

  const handleDelete=async(id)=>{
    const labourDelete=masterAPI["inspWoLabour"].delete
   await axiosPrivate.delete(`${labourDelete}/${id}`).then(res=>{
     console.log(res,"labour success")
     getData()
    }).catch(e=>{
      console.log(e,"error labour delete")
    })
  }

  const columns = [
    {
      Header: "Labour Code",
      accessor: "labourCode",
    },
    {
      Header: "Labour",
      accessor: "labourName",
    },
    {
      Header: "Craft",
      accessor: "craftName",
    },
    {
      Header: "Planned Hours",
      accessor: "plannedHours",
    },
    {
        Header: "Actions",
        Cell: ({ cell }) => {
          // console.log(cell)
          return (
            <Box sx={{ whiteSpace: "nowrap" }}>
              <IconButton 
              disabled={trueDisable}
                onClick={() => {
                    handleEdit(cell.row.original);
                  }}>
                <EditOutlined
                
                 
                  sx={{
                    fontSize: color.masterEditDelButton,
                    color:trueDisable?"default": color.masterEditDelButtonColor,
                  }}
                />
              </IconButton>
              <IconButton   
              disabled={trueDisable}
              onClick={() => {
                              handleDelete(cell.row.original.id);
                            }}>
                          <DeleteOutline
                           
                            sx={{
                              fontSize: color.masterEditDelButton,
                              color:trueDisable?"default": color.masterEditDelButtonColor,
                            }}
                          />
                        </IconButton>
            </Box>
          );
        },
      },
  ];
  return (
    <Box
      sx={{
        boxShadow: "-1px 1px 7px 2px rgb(0 0 0 / 32%)",
        p: 1.5,
        backgroundColor: "white",
        display: "flex",
        flexDirection: "column",
        gap: "1rem",
      }}
    >
      <Box sx={{display:"flex",alignItems:"center",width:"100%",justifyContent:"space-between"}}>
        <Typography
          sx={{
            color: color.masterDialogTitleColor,
            fontSize: color.masterDialogFontSize,
            fontWeight: 400,
          }}
        >
          Details
        </Typography>
       
        <IconButton
         sx={{backgroundColor:trueDisable?"default":color.TableButtonColor}} 
         disabled={trueDisable}
        onClick={()=>{setCreateLab(true)}}
        >
          <Add sx={{color:trueDisable?"default":"white"}}/>
        </IconButton>
       
      </Box>
      <Divider sx={{ border: "1px solid rgb(0 0 0 / 17%)",mt:"-0.7rem" }} />

      <Box>
        <NormalTable data={dataList} columns={columns} />
      </Box>
      <ResponsiveDialog
            open={createLab}
            onClose={()=>{
              setCreateLab(false)
            }}
            fullWidth
            maxWidth={"md"}
            children={
              <LabourCreate
                handleCloseClick={()=>{
                  setCreateLab(false)
                  getData()
                }}
               
                woData={woData}
               
              />
            }
          />
           <ResponsiveDialog
            open={editLabour}
            onClose={handleClose}
            fullWidth
            maxWidth={"md"}
            children={
              <LabourEdit
                handleCloseClick={()=>{handleClose()}}
               
                editData={editData}
               
              />
            }
          />
    </Box>
  );
};

export default WorkAssignment;
